import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe for replacing new lines with html line breaks
 *
 * @example {{ text | nl2br}}
 */
@Pipe({
    name: 'nl2br'
})
export class Nl2BrPipe implements PipeTransform {

    /**
     * Replaces new lines (\n) in a string with html line breaks (br)
     * @param text
     * @returns {String}
     */
    public transform(text: string) {
        if (typeof text === "undefined") { return ""; }

        return text.replace(/\n/g, '<br>');
    }
}
